import { loadable } from 'utils';

export const Billing = loadable(() => import('./Billing'), {});
export const InstitutionResponsible = loadable(() => import('./InstitutionResponsible'), {});
export const MinimumOrderRules = loadable(() => import('./MinimumOrderRules'), {});
export const Order = loadable(() => import('./Order'), {});
export const Product = loadable(() => import('./Product'), {});
export const Payments = loadable(() => import('./Payments'), {});
export const ShippingConfiguration = loadable(() => import('./ShippingConfiguration'), {});
